// src/components/BrandSection.js
import React from 'react';
import { applyImageFallback, getImageAssetUrl } from '../utils/imageAssets';

const TELEGRAM_ORDER_URL = 'https://t.me/kupivamerike_bot?start=2490149489';
const MAX_ORDER_URL = 'https://max.ru/id772310727548_bot?start=2490149489';

const categories = [
  {
    title: 'Одежда',
    image: '/images/categories/category-clothes.webp',
    fallbackImage: '/images/categories/category-clothes.png',
  },
  {
    title: 'Обувь и сумки',
    image: '/images/categories/category-shoes-bags.webp',
    fallbackImage: '/images/categories/category-shoes-bags.png',
  },
  {
    title: 'Аксессуары',
    image: '/images/categories/category-accessories.webp',
    fallbackImage: '/images/categories/category-accessories.png',
  },
  {
    title: 'Красота',
    image: '/images/categories/category-beauty.webp',
    fallbackImage: '/images/categories/category-beauty.png',
  },
  {
    title: 'Детская одежда и игрушки',
    image: '/images/categories/category-kids.webp',
    fallbackImage: '/images/categories/category-kids.png',
  },
  {
    title: 'Дом / быт',
    image: '/images/categories/category-home.webp',
    fallbackImage: '/images/categories/category-home.png',
  },
];

const BrandSection = () => {
  return (
    <section id="categories" className="container category-showcase-section">
      <div className="category-showcase">
        <div className="category-showcase-head">
          <p className="category-showcase-brand">SHOPTOP BRANDS</p>
          <h2>
            <span>Что можно</span> заказать
          </h2>
          <p className="category-showcase-subtitle">
            Оригинальные товары из США и Европы — от моды до lifestyle покупок
          </p>

            <p className="category-showcase-seo-text">
              Помогаем заказать подлинные товары с зарубежных сайтов и распродаж:
              кроссовки Nike, New Balance, Adidas, Asics и UGG; одежду Uniqlo,
              Zara, Massimo Dutti, Levi&apos;s, Ralph Lauren, Tommy Hilfiger,
              Calvin Klein и Hugo Boss; fashion-товары и аксессуары Chanel,
              Prada и других брендов по запросу.
            </p>
        </div>

        <div className="category-showcase-layout">
          <article className="category-showcase-main-card">
            <div className="category-showcase-main-text">
              <span className="category-showcase-badge">Популярно</span>
              <h3>Покупки для вашего стиля жизни</h3>
              <p>Любимые бренды, премиальное качество</p>
            </div>

            <img
              className="category-showcase-main-img"
              src={getImageAssetUrl('/images/categories/category-main.webp')}
              alt=""
              loading="lazy"
              decoding="async"
              onError={(event) =>
                applyImageFallback(event, '/images/categories/category-main.png')
              }
            />
          </article>

          <div className="category-showcase-grid">
            {categories.map((category) => (
              <a
                className="category-showcase-card"
                href="https://t.me/Shoptopbuyer"
                target="_blank"
                rel="noreferrer"
                key={category.title}
              >
                <span className="category-showcase-card-title">{category.title}</span>

                <img
                  className="category-showcase-card-img"
                  src={getImageAssetUrl(category.image)}
                  alt=""
                  loading="lazy"
                  decoding="async"
                  onError={(event) => applyImageFallback(event, category.fallbackImage)}
                />

                <span className="category-showcase-arrow" aria-hidden="true">→</span>
              </a>
            ))}
          </div>
        </div>

        <div className="category-showcase-bottom">
          <a
            className="category-showcase-telegram category-showcase-telegram-main"
            href={TELEGRAM_ORDER_URL}
            target="_blank"
            rel="noreferrer"
          >
            Оформить заказ в Telegram
          </a>

          <a
            className="category-showcase-telegram category-showcase-max"
            href={MAX_ORDER_URL}
            target="_blank"
            rel="noreferrer"
          >
            Оформить заказ в MAX
          </a>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
